import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'code',
  version: '1.0.0',
  properties: [
    {
      key: 'language',
      label: 'Language',
      type: 'options',
      required: true,
      default: 'javascript',
      options: [
        { value: 'javascript', name: 'JavaScript' },
        { value: 'python', name: 'Python' },
      ],
      description: 'Select the programming language for your code',
    },
    {
      key: 'executionTier',
      label: 'Execution Tier',
      type: 'options',
      required: true,
      default: 'sandboxed',
      options: [
        {
          value: 'sandboxed',
          name: 'Sandboxed',
          description: 'Secure execution with 5s timeout, standard library only'
        },
        {
          value: 'extended',
          name: 'Extended',
          description: '30s timeout with access to installed packages (npm/pip)'
        },
      ],
      description: 'Choose execution environment: Sandboxed (fast, secure) or Extended (more time, external libraries)',
    },
    {
      key: 'jsCode',
      label: 'JavaScript Code',
      type: 'string',
      required: false,
      default: `// Available variables:
// - items: Input data from previous node (array)
// - input: Raw input data object
// - $node: Access previous node outputs: $node["NodeName"].json
// - $vars: Workflow variables
// - $loop: Loop context (if inside a loop)
//
// Use 'return' statement to return data

// Example: Transform items array
return items.map(item => ({
  ...item,
  processed: true,
  timestamp: new Date().toISOString()
}));`,
      displayOptions: {
        show: {
          language: ['javascript']
        }
      },
      typeOptions: {
        editor: 'code',
        editorLanguage: 'javascript',
        rows: 15,
      },
      description: 'Write your JavaScript code here. Use return statement to return data.',
    },
    {
      key: 'pythonCode',
      label: 'Python Code',
      type: 'string',
      required: false,
      default: `# Available variables:
# - items: Input data from previous node (list)
# - input: Raw input data (dict)
# - $node: Access previous node outputs
# - $vars: Workflow variables (dict)
# - $loop: Loop context (if inside a loop)
#
# Assign result to 'result' variable

# Example: Transform items list
result = [
    {**item, "processed": True, "timestamp": datetime.now().isoformat()}
    for item in items
]`,
      displayOptions: {
        show: {
          language: ['python']
        }
      },
      typeOptions: {
        editor: 'code',
        editorLanguage: 'python',
        rows: 15,
      },
      description: 'Write your Python code here. Assign result to the result variable.',
    },
  ],
};

export default schema;
